<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline row hidden-xs">
                        <div class="col-xs-12">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>                   
                    </div>

                    <div class="row margin-top-20">
                        <div v-if="$root.user.tipo != 'contratante'" class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Visualize abaixo o relatório completo de notas fiscais emitidas.
                            </p>
                        </div>  
                        <div v-if="$root.user.tipo == 'contratante'" class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Visualize abaixo o seu relatório completo de notas fiscais emitidas.
                            </p>
                        </div>                                                    
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.nPagina = 1;get(true);" novalidate="">
                                <div class="flex-xl-nowrap row">
                                    <div v-if="$root.user.tipo == 'admin'" class="col-xs-12 col-md-12 col-lg-6 col-xl-fill">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>
                                                Cliente: 
                                                <a style="color: red;" class="float-right click" v-if="form.clienteCod" v-on:click="limparCliente()">
                                                    <i class="las la-trash"></i>
                                                    Limpar cliente
                                                </a>
                                            </h5>
                                            <autocomplete ref="clienteNome" :search="searchAutocompleteCliente" placeholder="Pesquise o cliente aqui..." aria-label="Pesquise o cliente aqui (nome, CNPJ..)" :get-result-value="getResultAutocompleteCliente" @submit="submitAutocompleteCliente"></autocomplete>                                            
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dEmiInicial">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dEmiFinal">
                                        </div>
                                    </div>         
                                    <div class="col-xs-fit align-self-md-end">
                                        <div class="submit-field margin-bottom-10">
                                            <button class="button color-gray" style="height: 50px; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>                         
                        
                        <div class="col-xl-12 col-xs-12">

                            <div v-show="data.nfseEncontradas.length == 0">
                                <center>
                                    <img src="static/images/empty.svg" style="width: 300px;">
                                    <h3 class="center" style="line-height: 120%; font-weight: 200">
                                        Nenhum resultado encontrado.
                                    </h3>
                                </center>     
                            </div>   

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.nfseEncontradas.length > 0">
                                <table class="child table table-bordered  table-responsive table-bordered-default">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            Nº
                                        </th>
                                        <th style="min-width: 200px;">
                                            Cliente
                                        </th>
                                        <th style="min-width: 110px; width: 110px; text-align: center;">
                                            Status
                                        </th>
                                        <th style="min-width: 120px; width: 120px; text-align: center;">
                                            Valor
                                        </th>                                   
                                        <th style="min-width: 140px; width: 140px; text-align: center;">
                                            Data emissão
                                        </th>
                                        <th style="min-width: 200px; width: 200px; text-align: center;">
                                            Ações
                                        </th>
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.nfseEncontradas">
                                            <td data-label="Nº:">
                                                {{item.Cabecalho.nNumeroNFSe}}
                                            </td>
                                            <td data-label="Cliente:" style="">
                                                <div v-if="item.cliente">
                                                    <router-link style="text-decoration: underline;" :to="{'name': 'EditarClientes', 'query': {'c': item.cliente.cod}}">
                                                        {{item.cliente.empresa ? item.cliente.empresa : item.cliente.nome}}
                                                    </router-link>
                                                </div>
                                                <div v-if="!item.cliente">
                                                    DESTINATÁRIO NÃO CADASTRADO
                                                </div>
                                                {{item.Cabecalho.cCNPJDestinatario ? ('CNPJ: ' + item.Cabecalho.cCNPJDestinatario) :  ''}}{{item.Cabecalho.cCPFDestinatario ? ('CPF: ' + item.Cabecalho.cCPFDestinatario) :  ''}}
                                            </td>
                                            <td data-label="Status:" style="text-align: center;">
                                                <span v-if="item.Cabecalho.cStatusNFSe == 'N'" class="dashboard-status-button color-orange">
                                                    Não faturada
                                                </span>
                                                <span v-if="item.Cabecalho.cStatusNFSe == 'F'" class="dashboard-status-button color-green">
                                                    Faturada
                                                </span>
                                                <span v-if="item.Cabecalho.cStatusNFSe == 'C'" class="dashboard-status-button color-red">
                                                    Cancelada
                                                </span>  
                                            </td>
                                            <td data-label="Valor:" style="text-align: center;">
                                                <a>
                                                    <b>R$ {{item.Cabecalho.nValorNFSe | toMoney}}</b>
                                                </a>
                                            </td>                               
                                            <td data-label="Data emissão:" style="text-align: center;">
                                                {{item.Emissao.cDataEmissao}} {{item.Emissao.cHoraEmissao}}
                                            </td>
                                            <td data-label="Ações:" style="text-align: center;">
                                                <p class="single segmented segmented-raised segmented-round">
                                                    <a  class="button button-round  color-green" v-on:click="visualizar(item)">
                                                        <i class="las la-eye"></i> Visualizar
                                                    </a>
                                                </p>        
                                            </td>               
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="click pagination-arrow" v-show="data.nPagina > 1" v-on:click="form.nPagina = (data.nPagina - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="click pagination-arrow" v-show="data.nPagina >= 1 && data.nPagina < data.nTotPaginas" v-on:click="form.nPagina = (data.nPagina + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="item in data.nTotPaginas">
                                            <a class="click" v-bind:class="{'current-page': item == data.nPagina}" v-on:click="form.nPagina = item; get(true);">
                                                {{item}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>            

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'NotasFiscais',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "data":                 {
                "nfseEncontradas":  []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "dEmiInicial":      "",
                "dEmiFinal":        "",
                "clienteCod":       "",
                // "cCNPJDestinatario":"",
                // "cCPFDestinatario": "",
                "nPagina":          1
            }              
        }
    },
    methods: {    
        limparCliente: function() {
            var self = this;
            console.log("limparCliente()", self)
            self.form.clienteCod = null;
            self.$refs.clienteNome.setValue(""); 
            setTimeout(function() {
                $("input").blur();
            }, 500);
            self.get();            
            self.$forceUpdate();
        },
        submitAutocompleteCliente: function(obj) {
            console.log("submitAutocompleteCliente", obj)
            var self = this;
            self.form.clienteCod = obj.cod;
            self.$forceUpdate();
            console.log("Setou form", self.form)
            self.form.nPagina           = 1;
            self.get();
        },        
        getResultAutocompleteCliente: function(result) {
          return (result.empresa ? result.empresa : result.nome);
        },            
        searchAutocompleteCliente: function(val, all) {
            var self = this;
            return new Promise(function(resolve, reject) {
                if (!val) {
                    resolve([]);
                    return false;
                }
    
                if (self.requestAutocomplete) {
                    self.requestAutocomplete.cancel(); 
                }

                self.requestAutocomplete = axios.CancelToken.source();  
                
                var form = {
                    "db":               "clientes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1,
                        "autocomplete": true,
                        "all":          (all || false),
                        "pesquisa":     val
                    },
                    "cancelToken":      self.requestAutocomplete.token  
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    resolve(response.data.result.itens);
  
                })
                .catch(error => {
                    loading.hide();
                    reject(error);
                }); 

            });
        },                   
        visualizar: function(item) {
            var self                = this;
            console.log("visualizar()", item);
            var form                = JSON.parse(JSON.stringify(self.form));
            form.nIdNf              = item.Cabecalho.nCodNF;
            loading.show();
            
            axios.get("api/notas-fiscais.php", {params: form})
            .then(response => {
                console.log("visualizar() response", response)
                loading.hide();
                if (response.data.result.cUrlNFSe) {
                    window.open(response.data.result.cUrlNFSe, "_blank");
                } else {
                    alert("Não foi possível obter a URL da NFS-e");
                }
            })
            .catch(error => {
                console.log("visualizar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });            
        },
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/notas-fiscais.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }                          
    },
    created: function() {
        var self = this;
    },
    activated: function() {
        var self = this;

        self.form.dEmiFinal = getNow(true);
        var dataFinal       = getNow(true) + (window.__app.mobile.osName.toLowerCase() == "ios"? "" : " 21:00:00");
        var novaData        = dateAdd(dataFinal, "months", -6);
        novaData            = getNow(true, false, novaData.getTime());
        self.form.dEmiInicial = novaData;


        loading.show();
        self.get(true).then(function() {              
            loading.hide();
        }).catch(function(error) {
            console.log("erro ao buscar", error);
            loading.hide();
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bloqueado {
        opacity: 0.5 !important;
    }

    .card .dashboard-status-button {
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/NotasFiscais.vue